import { render } from "./CometChatUI.vue?vue&type=template&id=6d2a2a2a&scoped=true"
import script from "./CometChatUI.vue?vue&type=script&lang=js"
export * from "./CometChatUI.vue?vue&type=script&lang=js"

import "./CometChatUI.vue?vue&type=style&index=0&id=6d2a2a2a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2a2a2a"]])

export default __exports__